import React from 'react';
import ReactDOM from 'react-dom';

import { I18nextProvider } from 'react-i18next';
import { i18n } from './i18n/i18n-browser';

// Apollo
import {
  ApolloClient,
  IntrospectionFragmentMatcher,
  InMemoryCache,
  HttpLink
} from 'apollo-boost';
import { ApolloProvider } from '@apollo/react-hooks';
import introspectionQueryResultData from './fragmentTypes.json';

import './scss/style.scss'
import ParagraphPageTitle from './general-components/content-base/paragraphs/paragraph-page-title';
import ParagraphText
  from './general-components/content-base/paragraphs/paragraph-text';
import ParagraphCallToAction
  from './general-components/content-base/paragraphs/paragraph-call-to-action';
import ParagraphMedia
  from './general-components/content-base/paragraphs/media-video-audio/paragraph-media';
import ParagraphAkkordionText
  from './general-components/content-base/paragraphs/paragraph-akkordion-text';
import SimpleHeader from './header/simple-header';
import PageFooter from './general-components/page-footer';
import ParagraphCalendar
  from './general-components/content-base/paragraphs/paragraph-calendar/paragraph-calendar';
import ParagraphSectionheading
  from './general-components/content-base/paragraphs/paragraph-sectionheading';
import ParagraphDownload
  from './general-components/content-base/paragraphs/paragraph-download';
import ShortMenu from './general-components/content-base/short-menu';
import ParagraphDossier
  from './general-components/content-base/paragraphs/paragraph-dossier';
import ParagraphGuestBook
  from './general-components/content-base/paragraphs/paragraph-guest-book';
import {restHost} from './config';
import ParagraphTeaserImage
  from './general-components/content-base/paragraphs/paragraph-teaser-image';
import ParagraphShop
  from './general-components/content-base/paragraphs/paragraph-shop';
import ParagraphShopProducts
  from './general-components/content-base/paragraphs/paragraph-shop-products';

// Redux
import {Provider} from 'react-redux';
import {
  createStore,
  combineReducers
} from 'redux';

// Reducer
import { calendarReducer } from './general-components/content-base/paragraphs/paragraph-calendar/calendar-reducer';
import { appReducer } from './general-components/reducer';
import { shopAccordionReducer } from './redux/paragraph-shop-products-reducer';
import ParagraphSponsorsList from "./general-components/content-base/paragraphs/paragraph-sponsors-list";

const
  apolloFragmentMatcher = new IntrospectionFragmentMatcher({ introspectionQueryResultData }),
  client = new ApolloClient({
    cache: new InMemoryCache({fragmentMatcher: apolloFragmentMatcher}),
    link: new HttpLink({ uri: `${restHost}/graphql`})
  }),
  store = createStore(
    combineReducers({
      appStore: appReducer,
      calenderStore: calendarReducer,
      shopAccordionStore: shopAccordionReducer
    }),
  );

window.onload = () => {

  /**
   * Render MainMenu
   * @type {Element}
   */

  const mainMenu = document.getElementById('site-header');

  if (mainMenu != null) {
    if (mainMenu.innerHTML === '') {
      ReactDOM.render(
        <Provider store={store}>
          <I18nextProvider i18n={i18n}>
            <SimpleHeader content={window.mainMenu} />
          </I18nextProvider>
        </Provider>,
        mainMenu
      )
    }
  }

  /**
   * Render Footer
   * @type {Element}
   */

  const footer = document.getElementById('page-footer');

  if (footer != null) {
    if (footer.innerHTML === '') {
      ReactDOM.render(
        <Provider store={store}>
          <I18nextProvider i18n={i18n}>
            <PageFooter footerConfig={window.footerConfig} footerMenu={window.footerMenu} footerLogoRow={window.footerLogoRow} />
          </I18nextProvider>
        </Provider>,
        footer
      )
    }
  }

  /**
   * Render ShortMenu
   * @type {Element}
   */

  const shortMenu = document.getElementById('short-menu');

  if (shortMenu != null) {
    if (shortMenu.innerHTML === '') {
      ReactDOM.render(
        <I18nextProvider i18n={i18n}><ShortMenu/></I18nextProvider>,
        shortMenu
      )
    }
  }



  /**
   * Startpoint for Page Titles
   *
   * @type {NodeListOf<Element>}
   */
  const pageTitleElements = document.querySelectorAll('.paragraph-seitentitel');

  for (const pageTitleElement of pageTitleElements) {
    const pageTitleContent = window[`pageTitle${pageTitleElement.getAttribute('data-decoupledid')}`];
    if (pageTitleContent) {
      ReactDOM.render(
        <I18nextProvider i18n={i18n}>
          <ParagraphPageTitle id={pageTitleElement.getAttribute('data-decoupledid')} content={pageTitleContent}/>
        </I18nextProvider>,
        pageTitleElement
      );
    }
  }

  /**
   * Startpoint for GuestBook
   *
   * @type {NodeListOf<Element>}
   */
  const GuestBookElements = document.querySelectorAll('.paragraph-guest-book');

  for (const guestBookElement of GuestBookElements) {
    const GuestBookContent = window[`guestBook${guestBookElement.getAttribute('data-decoupledid')}`];
    if (GuestBookContent) {
      ReactDOM.render(
        <I18nextProvider i18n={i18n}>
          <ParagraphGuestBook id={guestBookElement.getAttribute('data-decoupledid')} content={GuestBookContent}/>
        </I18nextProvider>,
        guestBookElement
      );
    }
  }

  /**
   * Startpoint for Section Heading
   *
   * @type {NodeListOf<Element>}
   */
  const sectionHeadingElements = document.querySelectorAll('.paragraph-section-heading');

  for (const sectionHeadingElement of sectionHeadingElements) {
    const sectionHeadingContent = window[`sectionHeading${sectionHeadingElement.getAttribute('data-decoupledid')}`];
    if (sectionHeadingContent) {
      ReactDOM.render(
        <I18nextProvider i18n={i18n}>
          <ParagraphSectionheading id={sectionHeadingElement.getAttribute('data-decoupledid')} content={sectionHeadingContent}/>
        </I18nextProvider>,
        sectionHeadingElement
      );
    }
  }

  /**
   * Startpoint for Kalender
   *
   * @type {NodeListOf<Element>}
   */
  const calendarElements = document.querySelectorAll('.paragraph-calendar');

  for (const calendarElement of calendarElements) {
    const calenderParagraphContent = window[`calenderParagraph${calendarElement.getAttribute('data-decoupledid')}`];
    ReactDOM.render(
      <Provider store={store}>
        <I18nextProvider i18n={i18n}>
          <ParagraphCalendar id={calendarElement.getAttribute('data-decoupledid')} content={calenderParagraphContent} />
        </I18nextProvider>
      </Provider>,
      calendarElement
    );
  }

  /**
   * Startpoint for Shop Paragraph.
   */
  const shopParagraphs = document.querySelectorAll('.paragraph--type--shop');

  for (const shopParagraph of shopParagraphs) {
    const shopParagraphContent = window[`shopParagraph${shopParagraph.getAttribute('data-decoupledid')}`];
    ReactDOM.render(
      <Provider store={store}>
        <I18nextProvider i18n={i18n}>
          <ParagraphShop id={shopParagraph.getAttribute('data-decoupledid')} content={shopParagraphContent} />
        </I18nextProvider>
      </Provider>,
      shopParagraph
    );
  }

  /**
   * Startpoint for Shop Paragraph.
   */
  const shopProductsParagraphs = document.querySelectorAll('.paragraph--type--shop-products');

  for (const shopProductsParagraph of shopProductsParagraphs) {
    const shopProductsParagraphContent = window[`shopProductsParagraph${shopProductsParagraph.getAttribute('data-decoupledid')}`];
    ReactDOM.render(
      <Provider store={store}>
        <I18nextProvider i18n={i18n}>
          <ParagraphShopProducts id={shopProductsParagraph.getAttribute('data-decoupledid')} content={shopProductsParagraphContent} />
        </I18nextProvider>
      </Provider>,
      shopProductsParagraph
    );
  }

  /**
   * Starting for Text Paragraphs
   *
   */
  const textParagraphsElements = document.querySelectorAll('.paragraph-text');

  for (const textParagraphsElement of textParagraphsElements) {
    const textParagraphContent = window[`sectionText${textParagraphsElement.getAttribute('data-decoupledid')}`];
    if (textParagraphContent) {
      ReactDOM.render(
        <I18nextProvider i18n={i18n}>
          <ParagraphText id={textParagraphsElement.getAttribute('data-decoupledid')} content={textParagraphContent}/>
        </I18nextProvider>,
        textParagraphsElement
      );
    }
  }

  /**
   * Starting for Text Image Paragraphs
   *
   */
  const textImageParagraphsElements = document.querySelectorAll('.paragraph-text-image');

  for (const textImageParagraphsElement of textImageParagraphsElements) {
    const textImageParagraphContent = window[`teaserImageText${textImageParagraphsElement.getAttribute('data-decoupledid')}`];
    if (textImageParagraphContent) {
      ReactDOM.render(
        <I18nextProvider i18n={i18n}>
          <ParagraphTeaserImage id={textImageParagraphsElement.getAttribute('data-decoupledid')} content={textImageParagraphContent}/>
        </I18nextProvider>,
        textImageParagraphsElement
      );
    }
  }


  /**
   * Startpoint for Dossier
   *
   */
  const dossierParagraphsElements = document.querySelectorAll('.paragraph-dossier');

  for (const dossierParagraphsElement of dossierParagraphsElements) {
    const dossierParagraphContent = window[`sectionDossier${dossierParagraphsElement.getAttribute('data-decoupledid')}`];
    if (dossierParagraphContent) {
      ReactDOM.render(
        <ApolloProvider client={client}>
          <I18nextProvider i18n={i18n}>
            <ParagraphDossier client={client} id={dossierParagraphsElement.getAttribute('data-decoupledid')} content={dossierParagraphContent}/>
          </I18nextProvider>
        </ApolloProvider>,
        dossierParagraphsElement
      );
    }
  }


  /**
   * Starting for Call to Action Paragraphs
   *
   */
  const callToActionParagraphsElements = document.querySelectorAll('.paragraph-call-to-action');

  for (const callToActionParagraphsElement of callToActionParagraphsElements) {
    const callToActionParagraphContent = window[`sectionCallToAction${callToActionParagraphsElement.getAttribute('data-decoupledid')}`];
    if (callToActionParagraphContent) {
      ReactDOM.render(
        <I18nextProvider i18n={i18n}>
          <ParagraphCallToAction id={callToActionParagraphsElement.getAttribute('data-decoupledid')} content={callToActionParagraphContent}/>
        </I18nextProvider>,
        callToActionParagraphsElement
      );
    }
  }

  /**
   * Starting for Call to Action Paragraphs
   *
   */
  const DownloadParagraphsElements = document.querySelectorAll('.paragraph-download');

  for (const downloadParagraphsElement of DownloadParagraphsElements) {
    const downloadParagraphContent = window[`sectionDownload${downloadParagraphsElement.getAttribute('data-decoupledid')}`];
    if (downloadParagraphContent) {
      ReactDOM.render(
        <I18nextProvider i18n={i18n}>
          <ParagraphDownload id={downloadParagraphsElement.getAttribute('data-decoupledid')} content={downloadParagraphContent}/>
        </I18nextProvider>,
        downloadParagraphsElement
      );
    }
  }

  /**
   * Starting for Video Paragraphs
   *
   */
  const videoParagraphsElements = document.querySelectorAll('.paragraph-video');

  for (const videoParagraphsElement of videoParagraphsElements) {
    const videoParagraphContent = window[`sectionVideo${videoParagraphsElement.getAttribute('data-decoupledid')}`];
    if (videoParagraphContent) {
      ReactDOM.render(
        <I18nextProvider i18n={i18n}>
          <ParagraphMedia id={videoParagraphsElement.getAttribute('data-decoupledid')} content={videoParagraphContent}/>
        </I18nextProvider>,
        videoParagraphsElement
      );
    }
  }

  /**
   * Starting for Akkordion Paragraphs
   *
   */
  const akkordionParagraphsElements = document.querySelectorAll('.paragraph-akkordion');

  for (const akkordionParagraphsElement of akkordionParagraphsElements) {
    const akkordionParagraphContent = window[`sectionAkkordion${akkordionParagraphsElement.getAttribute('data-decoupledid')}`];
    if (akkordionParagraphContent) {
      ReactDOM.render(
        <I18nextProvider i18n={i18n}>
          <ParagraphAkkordionText id={akkordionParagraphsElement.getAttribute('data-decoupledid')} content={akkordionParagraphContent}/>
        </I18nextProvider>,
        akkordionParagraphsElement
      );
    }
  }

  /**
   * Startpoint for Sponsors Paragraph.
   */
  const sponsorsParagraphs = document.querySelectorAll('.paragraph--type--sponsors-list');

  for (const sponsorParagraph of sponsorsParagraphs) {
    const sponsorParagraphContent = window[`sponsorList${sponsorParagraph.getAttribute('data-decoupledid')}`];
    ReactDOM.render(
      <Provider store={store}>
        <I18nextProvider i18n={i18n}>
          <ParagraphSponsorsList id={sponsorParagraph.getAttribute('data-decoupledid')} sponsors={sponsorParagraphContent} />
        </I18nextProvider>
      </Provider>,
      sponsorParagraph
    );
  }
}
